import React from "react";

function RussTestHTML() {
	return (
		<iframe
			title="AI Analyst Documentation"
			src="./src/ai-analyst-documentation.html"
			style={{ width: "100%", minHeight: "100vh", border: "0" }}
			sandbox="allow-scripts allow-same-origin"
			referrerPolicy="no-referrer"
		/>
	);
}

export default RussTestHTML;
